import { render, staticRenderFns } from "./PasswordForgotten.vue?vue&type=template&id=a58e3e5c&scoped=true&"
import script from "./PasswordForgotten.vue?vue&type=script&lang=js&"
export * from "./PasswordForgotten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58e3e5c",
  null
  
)

export default component.exports